import { SVGProps, Ref, forwardRef, useId } from 'react';

export const TalantixBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M11.52 2.3c-.347 0-.612.113-1.12.42-.26.16-.346.208-.471.27q-.667.305-1.288.41a5 5 0 0 1-.421.054c-.09.008-.152.008-.219.008h-.004c-.074 0-.132 0-.222-.008a4 4 0 0 1-.422-.05 5 5 0 0 1-1.28-.414 4 4 0 0 1-.464-.265c-.51-.308-.78-.426-1.131-.426-.57 0-1.081.227-1.51.652l-.031.027c-.422.437-.652.945-.652 1.522 0 .347.113.609.425 1.116.16.265.207.347.266.472a5.2 5.2 0 0 1 .413 1.292q.038.229.05.417c.009.09.009.148.009.219 0 .062 0 .128-.008.214-.012.13-.024.273-.055.422-.07.41-.203.846-.41 1.287l-.046.094c-.055.101-.09.168-.223.382-.308.508-.421.77-.421 1.112 0 .57.226 1.077.652 1.51l.023.024c.43.43.944.66 1.518.66.367 0 .66-.13 1.19-.453.265-.164.3-.188.402-.238a5.4 5.4 0 0 1 1.287-.41q.229-.036.422-.055c.09-.008.152-.008.218-.008.063 0 .129 0 .215.008.129.012.265.024.417.055.41.07.84.199 1.288.406l.004.004c.101.054.136.078.402.238.53.323.823.452 1.194.452.566 0 1.069-.222 1.502-.647.425-.434.695-.98.695-1.55 0-.347-.117-.612-.426-1.12-.164-.26-.207-.347-.269-.471a5.5 5.5 0 0 1-.41-1.288 7 7 0 0 1-.054-.421c-.004-.09-.008-.153-.008-.219 0-.07.004-.133.008-.218a5.086 5.086 0 0 1 .464-1.709l.012-.02c.054-.121.101-.199.257-.453.309-.507.426-.772.426-1.116 0-.573-.23-1.08-.652-1.514l-.023-.023c-.434-.421-.945-.652-1.518-.652"
                    fill={`url(#${_uniqueId}paint0_linear_9138_2268)`}
                    suppressHydrationWarning
                />
                <path
                    d="M8.005 1h-.039c-.542.004-1.038.172-1.428.566-.234.238-.34.573-.425.913l.12.062c.574.27 1.203.426 1.73.426.249 0 .912-.043 1.743-.43l.153-.078c-.086-.335-.192-.663-.422-.897-.398-.39-.893-.558-1.432-.562"
                    fill="#2A7FEE"
                    fillOpacity={0.15}
                />
                <path
                    d="M2.476 6.123c-.343.086-.679.188-.917.426-.39.39-.558.885-.561 1.428v.035c.003.542.171 1.042.561 1.436.235.234.558.347.894.433l.082-.156c.398-.866.43-1.553.43-1.744 0-.246-.044-.91-.43-1.745z"
                    fill="#2A7FEE"
                    fillOpacity={0.15}
                />
                <path
                    d="m13.452 6.112-.066.124c-.386.831-.425 1.495-.425 1.74 0 .192.03.886.429 1.745l.082.156c.347-.086.69-.187.928-.43.39-.393.559-.885.562-1.427v-.036c-.003-.546-.167-1.045-.562-1.44-.241-.241-.593-.343-.948-.432"
                    fill="#2A7FEE"
                    fillOpacity={0.15}
                />
                <path
                    d="M7.958 12.987c-.19 0-.87.03-1.724.421l-.149.086c.09.347.2.69.445.936.39.394.886.562 1.428.566l.04.004c.542-.004 1.033-.172 1.424-.566.238-.238.339-.577.425-.92q-.089-.055-.172-.098c-.847-.398-1.525-.43-1.717-.43"
                    fill="#2A7FEE"
                    fillOpacity={0.15}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.73 6.096H8.427v4.222c0 .238-.148.359-.453.359-.304 0-.452-.125-.452-.36V6.097H6.218c-.238 0-.359-.129-.359-.402 0-.261.125-.394.36-.394h3.507q.358.001.36.394c.007.273-.118.402-.356.402"
                    fill="white"
                />
            </g>
            <defs>
                <linearGradient
                    id={`${_uniqueId}paint0_linear_9138_2268`}
                    x1={2.897}
                    y1={2.912}
                    x2={13.07}
                    y2={13.085}
                    gradientUnits="userSpaceOnUse"
                    suppressHydrationWarning
                >
                    <stop stopColor="#6D44D4" />
                    <stop offset={1} stopColor="#2A7FEE" />
                </linearGradient>
            </defs>
        </svg>
    );
});
TalantixBrandSize16Glyph.displayName = 'TalantixBrandSize16Glyph';
